var ModalWindow = function ModalWindow(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "fullscreen"
  }, children);
};
export default ModalWindow;